export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Kirjaudu sisään",
    "login.form.hint.user": "Sisäänkirjaus",
    "login.form.hint.password": "Salasana",
    "login.form.checkbox.remember-me": "Muista minut",
    "login.form.button.sign-in": "Kirjaudu sisään",
    "login.form.message.invalid-user-credentials": "Kirjautumistunnus tai salasana on väärä",
    "login.form.message.account-temporarily-locked": "Tili on väliaikaisesti lukittu, palaa 5 minuutin kuluttua",
    "login.form.message.user-required": "Anna kirjautumistunnus",
    "login.form.message.password-required": "Anna salasana",
    "login.form.button.forgot-password": "Unohditko salasanasi?",
    "error.mfa-required.title": "Määritä 2FA",
    "error.mfa-required.message1": "Kaksivaiheinen todennus (2FA) vaaditaan tilisi suojaamiseksi.",
    "error.mfa-required.message2": "Sinut ohjataan tilisi asetuksiin Online Dashboardissa. Ota 2FA käyttöön, seuraa määritysohjeita ja palaa sitten tänne.",
    "error.mfa-required.learnMore": "Lisätietoja kaksivaiheisesta todennuksesta",
    "error.mfa-required.continue": "Jatka",
    "error.root-admin-login.title": "Virhe 403 – kielletty",
    "error.root-admin-login.message": "Olet kirjautunut vain luku -pääkäyttäjänä. Jos haluat käyttää Web Recovery -konsolia, kirjaudu asiakkaan haltijakäyttäjänä tai pääkäyttäjänä",
    "error.server-busy.message": "Palvelin on varattu, yritä myöhemmin uudelleen.",
    "error.network-connection.title": "Verkkoyhteysvirhe",
    "error.network-connection.message": "Tarkista Internet-yhteys ja yritä uudelleen.",
    "error.internal-server-error.title": "Palvelimen sisäinen virhe",
    "error.internal-server-error.message": "Selvitä virhe ottamalla yhteys tukeen ja ilmoittamalla virheen yksityiskohdat.",
    "error.internal-server-error.copy.button": "Kopioi"
};
